export const formatDiff = ({ value, formatter = (x) => x }) =>
  value < 0 ? formatter(value) : `+${formatter(value)}`
